import {useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import {Button} from "react-bootstrap";
import FilterOrder from "../components/FilterOrder/FilterOrder";
import InputGroup from 'react-bootstrap/InputGroup';

export const OrdersUnderwear = () => {

    const [orders, setOrders] = useState([{}])
    const [dataFB, setDataFB] = useState([])
    const [source, setSource] = useState('lava_underwear')
    const [manager, setManager] = useState('all')
    const [rangeDate, setRangeDate] = useState('day')
    const [timeLastUpdated, setTimeLastUpdated] = useState('')

    const [range, setRange] = useState({
        startDate: new Date(),
        endDate: new Date()
    });
    const [isLoading, setLoading] = useState(false);
    const [isLoadingY, setLoadingY] = useState(false);
    const [isLoadingCM, setLoadingCM] = useState(false);
    const [isLoadingPM, setLoadingPM] = useState(false);
    const [isLoadingT, setLoadingT] = useState(false);
    const [isUploadData, setUploadData] = useState(false);

    Date.prototype.getWeek = function() {
        const onejan = new Date(this.getFullYear(),0,1);
        const today = new Date(this.getFullYear(),this.getMonth(),this.getDate());
        const dayOfYear = ((today - onejan)/86400000);
        return Math.ceil(dayOfYear/7)
    };
    Date.prototype.get2Weeks = function() {
        const onejan = new Date(this.getFullYear(),0,1);
        const today = new Date(this.getFullYear(),this.getMonth(),this.getDate());
        const dayOfYear = ((today - onejan)/86400000);
        return Math.ceil(dayOfYear/14)
    };
    function sortProducts(a,b){
        a = a.quantity
        b = b.quantity
        if(a>b) return -1;
        if(a<b) return 1;
        return 0;
    }
    function sortHeaderUploadData(a,b){
        a = a.spend
        b = b.spend
        if(a>b) return -1;
        if(a<b) return 1;
        return 0;
    }

    function getDates(startDate, endDate, interval) {
        const duration = endDate - startDate;
        const steps = duration / interval;
        const dates = Array.from({length: steps+1}, (v,i) => new Date(startDate.valueOf() + (interval * i)))
        const result = dates.map((date)=> {
            const year = date.toLocaleString("default", { year: "numeric" });
            const month = date.toLocaleString("default", { month: "2-digit" });
            const day = date.toLocaleString("default", { day: "2-digit" });
            return year + "-" + month + "-" + day;
        });

        return result
    }

    function sortNames(a,b){
        a = a.name
        b = b.name
        if(a>b) return -1;
        if(a<b) return 1;
        return 0;
    }

    const getCustomNames = (arr, prop1, prop2) => {
        const arr1 = arr.map((item) => {
            const name = item.name
            if(name.includes("Комплект білизни")) item.name = "Комплект білизни"
            if(name === "Футболка Двонитка" || name === "Футболка") item.name = "Футболка"
            if(name.includes("Зіпхуді петля")) item.name = "Зіпхуді петля"
            if(name.includes("Джогери петля") || name.includes("Джогери чоловічі")) item.name = "Джогери петля"
            if(name.includes("Шорти петля") || name.includes("Шорти короткі")) item.name = "Шорти петля"
            if(name.includes("Худі петля")) item.name = "Худі петля"
            if(name.includes("Світшот петля")) item.name = "Світшот петля"
            if(name.includes("Палаццо")) item.name = "Палаццо"
            if(name.includes("Гольф")) item.name = "Гольф"
            if(name.includes("Купальник")) item.name = "Купальник"
            if(name === "Майка" || name.includes("Майка з кантом")) item.name = "Майка"
            if(name === "Карго" || name === "Карго 2023") item.name = "Карго"
            if(name === "Худі Фліс" || name.includes("Худі чоловічі Фліс")) item.name = "Худі Фліс"
            if(name === "Топ" || name === "Топ new" || name === "Топ new з чашечками" || name === "Труси new" || name === "Труси" || name === "Топ з чашечками") item.name = "Топ чи Труси окремо"
            if(name === "Труси Мустанг" || name === "Труси кенді" || name === "Труси SEX&CANDY") item.name = "Труси нові"
            return item
        });

        function getResult(arr) {
            let objProp1 = {};
            let objProp2 = {};

            arr.forEach(function(d) {
                if (objProp1.hasOwnProperty(d.name)) {
                    objProp1[d.name] = objProp1[d.name] + d[`${prop1}`];
                } else {
                    objProp1[d.name] = d[`${prop1}`];
                }
            });
            prop2 && arr.forEach(function(d) {
                if (objProp2.hasOwnProperty(d.name)) {
                    objProp2[d.name] = objProp2[d.name] + d[`${prop2}`];
                } else {
                    objProp2[d.name] = d[`${prop2}`];
                }
            });

            let result = [];

            for (let p1 in objProp1) {
                if(Object.keys(objProp2).length !== 0) {
                    for (let p2 in objProp2) {
                        p1 === p2 && result.push({ name: p1, [`${prop1}`]: objProp1[p1], [`${prop2}`]: objProp2[p2] })
                    }
                } else {
                    result.push({ name: p1, [`${prop1}`]: objProp1[p1]})
                }
            }

            console.log(result);
            return result
        }

        return  getResult(arr1)
    }
    const getStringDateUTC = stringDate => {
        const date = new Date(stringDate);
        const h = date.getUTCHours()
        const hh = h <= 9 ? '0' + h : h;
        const m = date.getUTCMinutes()
        const mm = m <= 9 ? '0' + m : m;
        const s = date.getUTCSeconds()
        const ss = s <= 9 ? '0' + s : s;
        const year = date.getUTCFullYear()
        let month = date.getUTCMonth() + 1
        month = month <= 9 ? '0' + month : month;
        let day = date.getUTCDate()
        day = day <= 9 ? '0' + day : day;
        return  year + "-" + month + "-" + day + " " + hh + ":" + mm + ":" + ss
    }
    const filterPrevDay = getPreviousDay()
    const filterCM = getCurrrentMonth()
    const filterPM = getPrevMonth()

    //*** This code is copyright 2002-2016 by Gavin Kistner, !@phrogz.net
    //*** It is covered under the license viewable at http://phrogz.net/JS/_ReuseLicense.txt
    Date.prototype.customFormat = function(formatString){
        var YYYY,YY,MMMM,MMM,MM,M,DDDD,DDD,DD,D,hhhh,hhh,hh,h,mm,m,ss,s,ampm,AMPM,dMod,th;
        YY = ((YYYY=this.getFullYear())+"").slice(-2);
        MM = (M=this.getMonth()+1)<10?('0'+M):M;
        MMM = (MMMM=["January","February","March","April","May","June","July","August","September","October","November","December"][M-1]).substring(0,3);
        DD = (D=this.getDate())<10?('0'+D):D;
        DDD = (DDDD=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"][this.getDay()]).substring(0,3);
        th=(D>=10&&D<=20)?'th':((dMod=D%10)==1)?'st':(dMod==2)?'nd':(dMod==3)?'rd':'th';
        formatString = formatString.replace("#YYYY#",YYYY).replace("#YY#",YY).replace("#MMMM#",MMMM).replace("#MMM#",MMM).replace("#MM#",MM).replace("#M#",M).replace("#DDDD#",DDDD).replace("#DDD#",DDD).replace("#DD#",DD).replace("#D#",D).replace("#th#",th);
        h=(hhh=this.getHours());
        if (h==0) h=24;
        if (h>12) h-=12;
        hh = h<10?('0'+h):h;
        hhhh = hhh<10?('0'+hhh):hhh;
        AMPM=(ampm=hhh<12?'am':'pm').toUpperCase();
        mm=(m=this.getMinutes())<10?('0'+m):m;
        ss=(s=this.getSeconds())<10?('0'+s):s;
        return formatString.replace("#hhhh#",hhhh).replace("#hhh#",hhh).replace("#hh#",hh).replace("#h#",h).replace("#mm#",mm).replace("#m#",m).replace("#ss#",ss).replace("#s#",s).replace("#ampm#",ampm).replace("#AMPM#",AMPM);
    };
    function getCurrrentMonth(date_today = new Date()) {
        const firstDay = new Date(date_today.getFullYear(), date_today.getMonth(), 1);
        const getStartYear = firstDay.toLocaleString("default", { year: "numeric" });
        const getStartMonth = firstDay.toLocaleString("default", { month: "2-digit" });
        const getStartDay = firstDay.toLocaleString("default", { day: "2-digit" });
        const getStartTime = "00:00:00"
        let startDateFormat = getStartYear + "-" + getStartMonth + "-" + getStartDay + " " + getStartTime;
        const startDateUTCFormatted = getStringDateUTC(startDateFormat)

        const lastDay = new Date(date_today.getFullYear(), date_today.getMonth() + 1, 0);
        const getEndYear = lastDay.toLocaleString("default", { year: "numeric" });
        const getEndMonth = lastDay.toLocaleString("default", { month: "2-digit" });
        const getEndDay = lastDay.toLocaleString("default", { day: "2-digit" });
        const getEndTime = "23:59:59"
        const endDateFormat = getEndYear + "-" + getEndMonth + "-" + getEndDay + " " + getEndTime;
        const endDateUTCFormatted = getStringDateUTC(endDateFormat)
        const filter = encodeURIComponent("filter[created_between]") + "=" + encodeURIComponent(startDateUTCFormatted + ", " + endDateUTCFormatted)
        return filter;
    }
    function getPrevMonth(date_today = new Date()) {
        const firstDay = new Date(date_today.getFullYear(), date_today.getMonth() - 1, 1);
        const getStartYear = firstDay.toLocaleString("default", { year: "numeric" });
        const getStartMonth = firstDay.toLocaleString("default", { month: "2-digit" });
        const getStartDay = firstDay.toLocaleString("default", { day: "2-digit" });
        const getStartTime = "00:00:00"
        let startDateFormat = getStartYear + "-" + getStartMonth + "-" + getStartDay + " " + getStartTime;
        const startDateUTCFormatted = getStringDateUTC(startDateFormat)

        const lastDay = new Date(date_today.getFullYear(), date_today.getMonth(), 0);
        const getEndYear = lastDay.toLocaleString("default", { year: "numeric" });
        const getEndMonth = lastDay.toLocaleString("default", { month: "2-digit" });
        const getEndDay = lastDay.toLocaleString("default", { day: "2-digit" });
        const getEndTime = "23:59:59"
        const endDateFormat = getEndYear + "-" + getEndMonth + "-" + getEndDay + " " + getEndTime;
        const endDateUTCFormatted = getStringDateUTC(endDateFormat)
        const filter = encodeURIComponent("filter[created_between]") + "=" + encodeURIComponent(startDateUTCFormatted + ", " + endDateUTCFormatted)
        return filter;
    }
    function getPreviousDay(date = new Date()) {
        const previous = new Date(date.getTime());
        previous.setDate(date.getDate() - 1);

        const getYear = previous.toLocaleString("default", { year: "numeric" });
        const getMonth = previous.toLocaleString("default", { month: "2-digit" });
        const getDay = previous.toLocaleString("default", { day: "2-digit" });
        const getStartTime = "00:00:00"
        const getEndTime = "23:59:59"
        let startDateFormat = getYear + "-" + getMonth + "-" + getDay + " " + getStartTime;
        const startDateUTCFormatted = getStringDateUTC(startDateFormat)
        const endDateFormat = getYear + "-" + getMonth + "-" + getDay + " " + getEndTime;
        const endDateUTCFormatted = getStringDateUTC(endDateFormat)
        const filterPrevDay = encodeURIComponent("filter[created_between]") + "=" + encodeURIComponent(startDateUTCFormatted + ", " + endDateUTCFormatted)
        return filterPrevDay;
    }

    const getStartYear = range.startDate.toLocaleString("default", { year: "numeric" });
    const getStartMonth = range.startDate.toLocaleString("default", { month: "2-digit" });
    const getStartDay = range.startDate.toLocaleString("default", { day: "2-digit" });
    const getStartTime = "00:00:00"
    let startDateFormat = getStartYear + "-" + getStartMonth + "-" + getStartDay + " " + getStartTime;
    const startDateUTCFormatted = getStringDateUTC(startDateFormat)

    const getEndYear = range.endDate.toLocaleString("default", { year: "numeric" });
    const getEndMonth = range.endDate.toLocaleString("default", { month: "2-digit" });
    const getEndDay = range.endDate.toLocaleString("default", { day: "2-digit" });
    const getEndTime = "23:59:59"
    const endDateFormat = getEndYear + "-" + getEndMonth + "-" + getEndDay + " " + getEndTime;
    const endDateUTCFormatted = getStringDateUTC(endDateFormat)

    const limit = "limit=50"
    const sort = "sort=id"
    const filter = encodeURIComponent("filter[created_between]") + "=" + encodeURIComponent(startDateUTCFormatted + ", " + endDateUTCFormatted)
    const includes = "include=" + encodeURIComponent("manager, status, payments, products.offer, tags")

    const parameters = [limit, sort, filter, includes].join("&")

    const startDateFB = encodeURIComponent(getStartYear + "-" + getStartMonth + "-" + getStartDay)
    const untilDateFB = encodeURIComponent(getEndYear + "-" + getEndMonth + "-" + getEndDay)

    function fetchDataFB(date, source) {
        const parameters = "time_range=%7B%22since%22%3A%22" + date + "%22%2C%22until%22%3A%22" + date + "%22%7D&limit=100&level=adset&fields=campaign_id,campaign_name,clicks,impressions,spend,cpc,cpm,ctr,reach"
        return fetch(`/api/ads?${parameters}&source=${source}`)
    }

    useEffect(() => {
        const fetchData = (parameters) => {
            console.log("> start fetchData")
            fetch(`/api/orders?${parameters}`).then(response => {
                if (!response.ok) {
                    console.error(`Помилка завантаження ${response.status}`)
                    if (response.status === 500) {
                        alert("Занадто часто, спробуйте пізніше")
                        throw new Error('Something went wrong.');
                    }
                }
                setLoading(false)
                setLoadingT(false)
                setLoadingY(false)
                setLoadingCM(false)
                setLoadingPM(false)
                return  response.json()
            }).then(data => {
                setOrders(data)
            }).catch(function(error) {
                console.log('Request failed', error);
            });
        }
        async function getData(source) {
            const start = new Date(startDateFB)
            const end = new Date(untilDateFB)
            const dayInterval = 1000 * 60 * 60 * 24; // 1 day
            const dates = getDates(start, end, dayInterval)

            const promises = dates.map(date => {
                return fetchDataFB(date, source);
            })
            const responses = await Promise.all(promises);
            const jsonData = await Promise.all(responses.map((r) => r.json()));

            const result = []
            dates.forEach((date, d) => {
                jsonData.forEach((item, i) => {
                    if (d === i) {
                        result.push({ads: item, date: date})
                    }
                })
            })
            setDataFB(result);

        };
        fetchData(parameters)
        isUploadData && getData(source).then()
        const now = new Date();
        var myString = now.customFormat("#hhh#:#mm#:#ss#");
        setTimeLastUpdated(myString)
    }, [isLoading, isLoadingT, isLoadingY, isLoadingCM, isLoadingPM]);

    useEffect(() => {
        const interval = setInterval(() => {
            addDataToDB(parametersCurrentMonth)
            console.log("================UPDATE DB================")
        }, 300000)
        return () => clearInterval(interval)
    }, []);

    function runAtSpecificTimeOfDay(hour, minutes, func) {
        const twentyFourHours = 86400000;
        const now = new Date();
        let eta_ms = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minutes, 0, 0).getTime() - now;
        if (eta_ms < 0)
        {
            eta_ms += twentyFourHours;
        }
        setTimeout(function() {
            //run once
            func();
            // run every 24 hours from now on
            setInterval(func, twentyFourHours);
        }, eta_ms);
    }

    const handleClickCreate = () => setLoading(true);
    const handleClickYestarday = () => {
        const yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)
        setRange(prevRange => ({ ...prevRange, startDate : yesterday }))
        setRange(prevRange => ({ ...prevRange, endDate : yesterday }))
        console.log("setRange 2")
        console.log("range=====" , range)
        console.log("setLoadingY")
        return setLoadingY(true)
    };
    const handleClickToday = () => {
        const today = new Date()
        setRange(prevRange => ({ ...prevRange, startDate : today }))
        setRange(prevRange => ({ ...prevRange, endDate : today }))
        return setLoadingT(true)
    };


    const parametersDB = [limit, sort, filter, includes].join("&")
    const parametersPrevDay = [limit, sort, filterPrevDay, includes].join("&")
    const parametersPrevMonth = [limit, sort, filterPM, includes].join("&")
    const parametersCurrentMonth = [limit, sort, filterCM, includes].join("&")

    const fetchDataForDB = async (parameters) => {
        const response = await fetch(`/api/orders?${parameters}`)
        return response.json()
    }

    let arrManagers = []
    let arrSources = []
    let arrRanges = ["day", "week", "2weeks", "month", "year"]

    orders.forEach(order => {
        if (Object.keys(order).length !== 0 && !arrManagers.length) return arrManagers.push(order.manager.full_name)
        if (Object.keys(order).length !== 0 && !arrManagers.includes(order.manager.full_name)) {
            arrManagers.push(order.manager.full_name)
        }
        if (Object.keys(order).length !== 0 && !arrSources.length) {
            switch (order.source_id) {
                case 1:
                case 2: arrSources.push("lava.studio.in")
                    break;
                case 4: arrSources.push("lava_underwear")
                    break;
            }
            if (!arrSources.includes("lava.studio.in")) return arrSources.push("lava.studio.in")
            if (!arrSources.includes("lava_underwear")) return arrSources.push("lava_underwear")
        }

    })

    const filterByStatus = order => {
        if(Object.keys(order).length !== 0) {
            return order.status.group_id === 1 || order.status.group_id === 3 || order.status.group_id === 4 || order.status.group_id === 5
        }
    }
    const filterByGrandTotal = order => {
        if(Object.keys(order).length !== 0) {
            return order.grand_total > 0
        }
    }

    const filterByTags = order => {
        const isNoWholesale = (currentValue) => currentValue.id !== 4;
        if(Object.keys(order).length !== 0) {
            return order.tags.every(isNoWholesale)
        }
    }

    console.log("orders:", orders)

    let filteredOrders = orders.filter(filterByTags).filter(filterByStatus).filter(filterByGrandTotal).filter((order) => {
      if(Object.keys(order).length !== 0) {
          if (source === "lava.studio.in" && order.manager.full_name === manager) {
              return order.source_id === 1 && order.manager.full_name === manager || order.source_id === 2 && order.manager.full_name === manager
          } else if (source === "lava_underwear" && order.manager.full_name === manager) {
              return order.source_id === 4 && order.manager.full_name === manager
          } else if (source === "lava.studio.in" && manager === "all") {
              return order.source_id === 1 || order.source_id === 2
          } else if (source === "lava_underwear" && manager === "all") {
              return order.source_id === 4
          } else if (source === "all" && order.manager.full_name === manager) {
             return order.manager.full_name === manager
          } else if (source === "all" && manager === "all") {
              return  order
          }
      }
    })

    let grand_total = 0
    let quantityProducts = 0
    let margin_sum = 0
    let numberOfClearanceSales = 0
    let quantityRepeatSales = 0
    let arrProducts = []


    const getLocaleDate = (utcDate) => {
        let localeDate = new Date(utcDate);
        const getLocaleDateYear = localeDate.toLocaleString("default", { year: "numeric" });
        const getLocaleDateMonth = localeDate.toLocaleString("default", { month: "2-digit" });
        const getLocaleDateDay = localeDate.toLocaleString("default", { day: "2-digit" });
        const result = getLocaleDateDay + "-" + getLocaleDateMonth + "-" + getLocaleDateYear;
        return result
    }
    const getOrdersByRange = (arr, range) => {

        return arr.reduce((a, c) => {
            let eDate, cDate;
            let idx = a.findIndex((e) => {
                switch (range) {
                    case 'day':
                        eDate = getLocaleDate(e[0].created_at)
                        cDate = getLocaleDate(c.created_at)
                        break;
                    case 'week':
                        eDate = new Date(e[0].created_at).getWeek()
                        cDate = new Date(c.created_at).getWeek()
                        break;
                    case '2weeks':
                        eDate = new Date(e[0].created_at).get2Weeks()
                        cDate = new Date(c.created_at).get2Weeks()
                        break;
                    case 'month':
                        eDate = new Date(e[0].created_at).getMonth()
                        cDate = new Date(c.created_at).getMonth()
                        break;
                    case 'year':
                        eDate = new Date(e[0].created_at).getFullYear()
                        cDate = new Date(c.created_at).getFullYear()
                        break;
                }
                return eDate === cDate
            });
            if (idx !== -1) a[idx].push(c);
            else a.push([c]);
            return a;
        }, []);
    }
    let ranges = {}
    ranges.spend = []
    ranges.clicks = []
    ranges.ranges = getOrdersByRange(filteredOrders, rangeDate)


    filteredOrders.forEach(order => {
        grand_total = grand_total + order.grand_total
        margin_sum = margin_sum + order.margin_sum
        if (order.tags.length !== 0) {
            order.tags.forEach(tag => {
                if (tag.id === 5) return quantityRepeatSales++
                if (tag.id === 6) return numberOfClearanceSales++
            })
        }

        order.products.forEach(product => {
            quantityProducts = quantityProducts + product.quantity
            arrProducts.push({name: product.name, quantity: product.quantity})
        })
    })
    let productsAllOfPeriod = arrProducts.reduce((a, c) => {
        let idx = a.findIndex((e) => e.name === c.name);
        if (idx === -1) a.push(c)
        else a[idx].quantity = a[idx].quantity + c.quantity
        return a;
    }, []);

    productsAllOfPeriod.sort(sortProducts)

    const onFilterValueSelected = filterValue => setSource(filterValue)
    const onManagerSelected = manager => setManager(manager)
    const onRangeSelected = range => setRangeDate(range)
    const handleChangeUpLoading = () => setUploadData(!isUploadData);

    const addDataToDB = async (parameters) => {
        await handleRemoveData()
        const data = await fetchDataForDB(parameters)
        const dataDB = data.filter(filterByStatus).filter(filterByTags).filter(filterByGrandTotal).filter((order) => {
            if(Object.keys(order).length !== 0) return order.source_id === 1 || order.source_id === 2
        })
        const dataDBU = data.filter(filterByStatus).filter(filterByTags).filter(filterByGrandTotal).filter((order) => {
            if(Object.keys(order).length !== 0) return order.source_id === 4
        })
        let rangesDB = getOrdersByRange(dataDB,'day')
        let rangesDBU = getOrdersByRange(dataDBU,'day')
        const result = rangesDB.map((day, i) => {
            let grand_total = 0
            let quantityProducts = 0
            let margin_sum = 0
            let numberOfClearanceSales = 0
            let quantityRepeatSales = 0
            let arr = []

            day.forEach(order => {
                grand_total = grand_total + order.grand_total
                margin_sum = margin_sum + order.margin_sum

                if (order.tags.length !== 0) {
                    order.tags.forEach(tag => {
                        if (tag.id === 5) return quantityRepeatSales++
                        if (tag.id === 6) return numberOfClearanceSales++
                    })
                }

                order.products.forEach(product => {
                    quantityProducts = quantityProducts + product.quantity
                    arr.push({name: product.name, quantity: product.quantity})
                })
            })

            let productsDay = arr.reduce((a, c) => {
                let idx = a.findIndex((e) => e.name === c.name);
                if (idx === -1) a.push(c)
                else a[idx].quantity = a[idx].quantity + c.quantity
                return a;
            }, []);
            productsDay = getCustomNames(productsDay, "quantity")
            console.log("productsDay:", productsDay)
            return {
                date: day[0].created_at,
                dateLocal: getLocaleDate(day[0].created_at),
                quantityOrders: day.length,
                quantityRepeatSales: quantityRepeatSales,
                numberOfClearanceSales: numberOfClearanceSales,
                grand_total: Math.floor(grand_total),
                margin_sum: Math.floor(margin_sum),
                quantityProducts: quantityProducts,
                productsDay: productsDay
            }
        });
        const resultU = rangesDBU.map((day, i) => {
            let grand_total = 0
            let quantityProducts = 0
            let margin_sum = 0
            let numberOfClearanceSales = 0
            let quantityRepeatSales = 0
            let arr = []

            day.forEach(order => {
                grand_total = grand_total + order.grand_total
                margin_sum = margin_sum + order.margin_sum

                if (order.tags.length !== 0) {
                    order.tags.forEach(tag => {
                        if (tag.id === 5) return quantityRepeatSales++
                        if (tag.id === 6) return numberOfClearanceSales++
                    })
                }

                order.products.forEach(product => {
                    quantityProducts = quantityProducts + product.quantity
                    arr.push({name: product.name, quantity: product.quantity})
                })
            })

            let productsDay = arr.reduce((a, c) => {
                let idx = a.findIndex((e) => e.name === c.name);
                if (idx === -1) a.push(c)
                else a[idx].quantity = a[idx].quantity + c.quantity
                return a;
            }, []);
            productsDay = getCustomNames(productsDay, "quantity")
            console.log("productsDay:", productsDay)
            return {
                date: day[0].created_at,
                dateLocal: getLocaleDate(day[0].created_at),
                quantityOrders: day.length,
                quantityRepeatSales: quantityRepeatSales,
                numberOfClearanceSales: numberOfClearanceSales,
                grand_total: Math.floor(grand_total),
                margin_sum: Math.floor(margin_sum),
                quantityProducts: quantityProducts,
                productsDay: productsDay
            }
        });
        await fetch('/api/orders', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(result)
        }
        )
        await fetch('/api/u_orders', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(resultU)
        }
        )
    }
    const handleAddData = async () => {
        addDataToDB(parametersDB)
    }

    const handleAddPrevDay = () => {
        addDataToDB(parametersPrevDay)
    }
    const handleAddCurrentMonth = () => {
        addDataToDB(parametersCurrentMonth)
        return setLoadingCM(true)
    }
    const handleAddPrevMonth = () => {
        addDataToDB(parametersPrevMonth)
        return setLoadingPM(true)
    }
    async function handleRemoveData() {
        await fetch('/api/orders', {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({})})
        await fetch('/api/u_orders', {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({})})
        await console.log("DELETED!")
    }

    let sumSpend = 0
    let productsFB = []

    const dailyDataFromFB = dataFB.map(day => {   // массив дней где day єто object
        const dataAnalitics = []  // массив прорекламированних товаров
        let sumSpendFB = 0  // потрачений дневной бюджет
        let sumClicksFB = 0 // количество кликов за день

        day.ads.forEach(ad => { // массив реклам за день
            let names = ad.campaign_name.replace(/\(([^)]*)\).*/, '').replace(/  +/g, ' ');
            const products = names.split(",")
            const spend = +ad.spend
            const clicks = +ad.clicks
            sumSpendFB = sumSpendFB + spend
            sumClicksFB = sumClicksFB + clicks
            products.forEach((product, i)=> {
                //
                dataAnalitics.push({name: product.trim(), spend: +(parseFloat(spend)/products.length).toFixed(2), clicks: clicks/products.length})
            })
        })
        let arrProductsFB = dataAnalitics.reduce((a, c) => {
            let idx = a.findIndex((e) => e.name.toLowerCase() === c.name.toLowerCase());
            if (idx !== -1 && a.length !== 0 && a[idx].name.toLowerCase() === c.name.toLowerCase()) {
                a[idx].spend = +(a[idx].spend + c.spend).toFixed(2)
                a[idx].clicks = a[idx].clicks + c.clicks
            } else a.push(c);
            return a;
        }, []).sort(sortNames);
        arrProductsFB.forEach((p)=>{
            productsFB.push({name: p.name, spend: p.spend, clicks: p.clicks})
        })
        return {date: day.date, spend: sumSpendFB.toFixed(2), clicks: sumClicksFB, productsOnAds: arrProductsFB}
    })
    // console.log("dailyDataFromFB:", dailyDataFromFB)
    // console.log("productsFB:", productsFB)
    let productsAllOfPeriodFB = productsFB.reduce((a, c) => {
        let idx = a.findIndex((e) => e.name === c.name);
        if (idx === -1) a.push(c)
        else a[idx].spend = +(a[idx].spend + c.spend).toFixed(2)
        return a;
    }, []);
    productsAllOfPeriodFB.sort(sortHeaderUploadData);
    productsAllOfPeriodFB = getCustomNames(productsAllOfPeriodFB, "spend", "clicks")
    let spends_total = 0
    let clicks_total = 0

    productsAllOfPeriod = getCustomNames(productsAllOfPeriod, "quantity")
    // const difference = productsAllOfPeriodFB.filter((element) => {
    //     !productsAllOfPeriod.includes(element.name.toLowerCase())
    // });
    // const difference = productsAllOfPeriodFB.reduce((result, element) => {
    //     if (productsAllOfPeriod.indexOf(element.name.toLowerCase()) === -1) {
    //         result.push(element);
    //     }
    //     return result;
    // }, []);

    // A comparer used to determine if two entries are equal.
    const isSameUser = (a, b) => a.name === b.name

// Get items that only occur in the left array,
// using the compareFunction to determine equality.
    const onlyInLeft = (left, right, compareFunction) =>
        left.filter(leftValue =>
            !right.some(rightValue =>
                compareFunction(leftValue, rightValue)));

    const onlyInA = onlyInLeft(productsAllOfPeriodFB, productsAllOfPeriod, isSameUser);
    const onlyInB = onlyInLeft(productsAllOfPeriod, productsAllOfPeriodFB, isSameUser);

    const difference = [...onlyInA, ...onlyInB];

    console.log(difference);

    return (<>
        <header className="header-orders">
            <div className="section-controls">
                <p>Updated at <strong>{timeLastUpdated}</strong></p>
                <InputGroup className="mb-3">
                <div className="holder-datapickers">
                    <DatePicker dateFormat="dd.MM.yyyy" locale="uk" selected={range.startDate} onChange={date => setRange(prevRange => ({ ...prevRange, startDate : date }))} />
                    <DatePicker dateFormat="dd.MM.yyyy" locale="uk" selected={range.endDate} onChange={date => setRange(prevRange => ({ ...prevRange, endDate : date }))}  />
                </div>
                </InputGroup>
                <InputGroup className="mb-3">
                <Button
                    variant="outline-dark"
                    disabled={isLoading}
                    onClick={!isLoading ? handleClickCreate : null}
                >
                    {isLoading ? 'Loading…' : 'Створити'}
                </Button>
                <Button
                    variant="outline-dark"
                    onClick={!isLoadingT ? handleClickToday : null}
                >
                    {isLoadingT ? 'Loading…' : 'Сьогодні'}
                </Button>
                <Button
                    variant="outline-dark"
                    onClick={!isLoadingY ? handleClickYestarday : null}
                >
                    {isLoadingY ? 'Loading…' : 'Вчора'}
                </Button>
            </InputGroup>
            <InputGroup className="mb-3">
                    <FilterOrder options={arrSources} filterValueSelected={onFilterValueSelected}/>
                    <FilterOrder options={arrManagers} filterValueSelected={onManagerSelected}/>
                    <FilterOrder options={arrRanges} filterValueSelected={onRangeSelected}/>
                </InputGroup>
                <InputGroup className="mb-3">
                    <InputGroup.Checkbox onChange={handleChangeUpLoading} aria-label="Checkbox for following text input" /><label>Вигрузка</label>
                </InputGroup>
            </div>
            <div>
                <Button
                    variant="outline-dark"
                    onClick={handleAddData}
                >Додати замовлення в БД</Button>
                <Button
                    variant="outline-dark"
                    onClick={handleRemoveData}
                >Очистити БД</Button>
                <Button
                    variant="outline-dark"
                    onClick={handleAddPrevDay}
                >Додати вчорашній день</Button>
                <Button
                    variant="outline-dark"
                    onClick={!isLoadingCM ? handleAddCurrentMonth : null}
                >
                    {isLoadingCM ? 'Loading…' : 'Поточний місяць'}
                </Button>
                <Button
                    variant="outline-dark"
                    onClick={!isLoadingPM ? handleAddPrevMonth : null}
                >
                    {isLoadingPM ? 'Loading…' : 'Минулий місяць'}
                </Button>
            </div>
        </header>
        <main>
            <div className="container-fluid px-0">
                <section className="section-table">
                    <div className="holder-table">
                        <table className="table table-orders table-bordered table-striped">
                            <thead className="stiky header-table">
                            <tr>
                                {
                                    <>
                                        <th>дата</th>
                                        <th>Кількість замовлень</th>
                                        <th>Кількість повторних продажів, шт.</th>
                                        <th>Кількість замовлень з SALE, шт.</th>
                                        <th>Загальна вартість, грн.</th>
                                        <th>Маржа, грн.</th>
                                        <th>Зарплата, грн.</th>
                                        <th>Середній чек, грн.</th>
                                        <th>Кількість товарів, шт.</th>
                                        {productsAllOfPeriod.map((p, i) => <th className="product-name" key={i}>{p.name}</th>)}
                                    </>
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {ranges.ranges.map((range, i) => {
                                let grand_total = 0
                                let quantityProducts = 0
                                let margin_sum = 0
                                let numberOfClearanceSales = 0
                                let quantityRepeatSales = 0
                                let arr = []

                                range.forEach(order => {
                                    grand_total = grand_total + order.grand_total
                                    margin_sum = margin_sum + order.margin_sum

                                    if (order.tags.length !== 0) {
                                        order.tags.forEach(tag => {
                                            if (tag.id === 5) return quantityRepeatSales++
                                            if (tag.id === 6) return numberOfClearanceSales++
                                        })
                                    }

                                    order.products.forEach(product => {
                                        quantityProducts = quantityProducts + product.quantity
                                        arr.push({name: product.name, quantity: product.quantity})
                                    })
                                })

                                let productsDay = arr.reduce((a, c) => {
                                    let idx = a.findIndex((e) => e.name === c.name);
                                    if (idx === -1) a.push(c)
                                    else a[idx].quantity = a[idx].quantity + c.quantity
                                    return a;
                                }, []);

                                productsDay = getCustomNames(productsDay, "quantity")

                                return <tr key={i} className="day-data">
                                    <td className="date">{getLocaleDate(range[0].created_at)}</td>
                                    <td>{range.length}</td>
                                    <td>{quantityRepeatSales}</td>
                                    <td>{numberOfClearanceSales}</td>
                                    <td>{Math.floor(grand_total)}</td>
                                    <td>{Math.floor(margin_sum)}</td>
                                    <td>{quantityProducts * 40}</td>

                                    <td>{Math.floor(grand_total/range.length)}</td>
                                    <td>{quantityProducts}</td>
                                    {productsAllOfPeriod.map((valueTh, ith) => {
                                        let quantity = ""
                                        productsDay.forEach((p, pi) => {
                                            if (valueTh.name === p.name) {
                                                quantity = p.quantity
                                            }
                                        })
                                        return <td key={ith}>{quantity}</td>
                                    })}
                                </tr>
                            })}
                            </tbody>
                            {ranges.ranges.length > 1 && <tfoot>
                            <tr>
                                <td><strong>Взагалом</strong></td>
                                <td><strong>{filteredOrders.length}</strong></td>
                                <td><strong>{quantityRepeatSales}</strong></td>
                                <td><strong>{numberOfClearanceSales}</strong></td>
                                <td><strong>{Math.floor(grand_total)}</strong></td>
                                <td><strong>{Math.floor(margin_sum)}</strong></td>
                                <td><strong>{quantityProducts * 40}</strong></td>
                                <td><strong>{Math.floor(grand_total/filteredOrders.length)}</strong></td>
                                <td><strong>{quantityProducts}</strong></td>
                                {productsAllOfPeriod.map((p, i) => <td key={i}><strong>{p.quantity}</strong></td>)}
                            </tr>
                            </tfoot>}
                        </table>
                    </div>
                </section>
                {isUploadData && <section className="section-upload">
                    <table className="table table-orders table-bordered table-striped">
                        <thead className="sticky header-table">
                        <tr>
                            {
                                <>
                                    <th>Дата</th>
                                    <th>Бюджет</th>
                                    <th>Кількість кліків</th>
                                    {productsAllOfPeriodFB.map((p, i) => <th className="product-name"
                                                                             key={i}>{p.name}</th>)}
                                </>
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {dailyDataFromFB.map((day, i) => {
                            clicks_total = clicks_total + +day.clicks
                            spends_total = spends_total + +day.spend
                            return <tr key={i} className="day-data">
                                <td className="date">{day.date}</td>
                                <td>{day.spend}</td>
                                <td>{day.clicks}</td>
                                {productsAllOfPeriodFB.map((valueTh, ith) => {
                                    let value = ""
                                    day.productsOnAds.forEach((p, pi) => {
                                        if (valueTh.name === p.name) {
                                            value = Math.round(p.spend)
                                        }
                                    })
                                    return <td key={ith}>{value}</td>
                                })}
                            </tr>
                        })}
                        </tbody>
                        {dailyDataFromFB.length > 1 && <tfoot>
                        <tr>
                            <td><strong>Взагалом</strong></td>
                            <td><strong>{spends_total.toFixed(2)}</strong></td>
                            <td><strong>{clicks_total}</strong></td>
                            {productsAllOfPeriodFB.map((p, i) => <td key={i}><strong>{p.spend}</strong></td>)}
                        </tr>
                        </tfoot>}
                    </table>
                    {productsAllOfPeriodFB.map((p1, i) => {
                        sumSpend = sumSpend + p1.spend
                        return productsAllOfPeriod.map((p2, i) => {
                            if(p1.name.toLowerCase() === p2.name.toLowerCase()) return <p key={i}>{p1.name} = {p1.spend} / {p2.quantity} = {+(p1.spend/p2.quantity).toFixed(2)}</p>
                    }) })}
                    {<div><strong>Сумма:</strong> {+sumSpend.toFixed(2)}</div>}
                </section>}
            </div>
        </main></>

    );
}